module.exports = __webpack_public_path__ + "img/four-four.e66b4c38.png";